import { render, staticRenderFns } from "./ModifyModal.vue?vue&type=template&id=cb88ebec&scoped=true&"
import script from "./ModifyModal.vue?vue&type=script&lang=js&"
export * from "./ModifyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb88ebec",
  null
  
)

export default component.exports